import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, CalendarCheck, Sparkles } from 'lucide-react';
import { trackEvent } from '@/lib/analytics';

/**
 * Fixed mobile bottom bar with 3 always-visible CTAs:
 *   ESSAI GRATUIT · RÉSERVER · APPELER
 * Shown only on < md screens. Hidden on /admin. Appears after small scroll.
 */
export function StickyMobileCTA() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 250);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (pathname.startsWith('/admin')) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="md:hidden fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pt-2 bg-gradient-to-t from-black/60 to-transparent pointer-events-none"
          data-testid="sticky-mobile-cta"
        >
          <div className="flex items-stretch gap-2 pointer-events-auto">
            <Link
              to="/contact"
              onClick={() => trackEvent('cta_essai_click', { location: 'sticky_mobile' })}
              data-testid="sticky-cta-essai"
              className="flex-1 flex items-center justify-center gap-2 h-14 bg-primary hover:bg-primary-dark text-white rounded-xl font-heading text-[13px] tracking-wider shadow-[0_10px_30px_-10px_rgba(45,110,70,0.7)] active:scale-[0.98] transition-transform"
            >
              <Sparkles className="h-4 w-4" />
              ESSAI GRATUIT
            </Link>
            <Link
              to="/reservation"
              onClick={() => trackEvent('reservation_click', { location: 'sticky_mobile' })}
              data-testid="sticky-cta-reserve"
              className="flex-1 flex items-center justify-center gap-2 h-14 bg-white text-primary rounded-xl font-heading text-[13px] tracking-wider shadow-lg active:scale-[0.98] transition-transform"
            >
              <CalendarCheck className="h-4 w-4" strokeWidth={2.4} />
              RÉSERVER
            </Link>
            <a
              href="tel:+33684284087"
              onClick={() => trackEvent('phone_click', { location: 'sticky_mobile' })}
              data-testid="sticky-cta-phone"
              aria-label="Appeler CrossFit Saint-Chamond"
              className="w-14 h-14 flex items-center justify-center bg-dark text-white rounded-xl shadow-lg active:scale-[0.98] transition-transform"
            >
              <Phone className="h-5 w-5" strokeWidth={2.4} />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
